(() => {
  async function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const grid = root.querySelector('[data-limited-grid]');
    const brand = root.querySelector('[data-limited-brand]');
    const kind = root.querySelector('[data-limited-kind]');
    const sort = root.querySelector('[data-limited-sort]');
    const stock = root.querySelector('[data-limited-stock]');
    const status = root.querySelector('[data-limited-status]');
    const more = root.querySelector('[data-limited-more]');
    const fallback = root.querySelector('[data-limited-fallback]');
    const errorMessage = root.querySelector('[data-limited-error]');
    const loadingText = status.textContent;
    const cards = Array.from(grid.querySelectorAll('[data-limited-card]'));
    const ids = new Set(cards.map(card => card.dataset.id));
    let pinned = cards.filter(card => !card.hidden && card.dataset.stock === 'true').slice(0, 24);
    let limit = 24;
    let complete = false;
    let failed = false;
    function diversify(items) {
      const groups = new Map();
      items.forEach(card => {
        if (!groups.has(card.dataset.brand)) groups.set(card.dataset.brand, []);
        groups.get(card.dataset.brand).push(card);
      });
      const ordered = [];
      while (ordered.length < items.length) groups.forEach(group => { if (group.length) ordered.push(group.shift()); });
      return ordered;
    }
    function paint() {
      const kept = new Set(pinned);
      const edit = [...pinned, ...diversify(cards.filter(card => card.dataset.stock === 'true' && !kept.has(card))), ...diversify(cards.filter(card => card.dataset.stock !== 'true'))];
      const selected = edit.filter(card => (!brand.value || card.dataset.brand === brand.value) && (!kind.value || card.dataset.kind === kind.value) && (!stock.checked || card.dataset.stock === 'true'));
      if (sort.value !== 'edit') selected.sort((a, b) => sort.value === 'low' ? +a.dataset.price - +b.dataset.price : +b.dataset.price - +a.dataset.price);
      const visible = selected.slice(0, limit);
      const visibleSet = new Set(visible);
      cards.forEach(card => { card.hidden = !visibleSet.has(card); });
      let cursor = grid.firstElementChild;
      selected.forEach(card => {
        if (card === cursor) cursor = cursor.nextElementSibling;
        else grid.insertBefore(card, cursor);
      });
      if (!complete) pinned = visible.filter(card => card.dataset.stock === 'true');
      status.hidden = failed;
      status.textContent = complete ? root.dataset.countLabel.replace('__COUNT__', selected.length) : loadingText;
      root.querySelector('[data-limited-empty]').hidden = !complete || failed || selected.length !== 0;
      more.hidden = limit >= selected.length;
    }
    const append = incoming => {
      const fragment = document.createDocumentFragment();
      incoming.querySelectorAll('[data-limited-card]').forEach(card => {
        if (!ids.has(card.dataset.id)) {
          card.hidden = true;
          cards.push(card);
          ids.add(card.dataset.id);
          fragment.append(card);
        }
      });
      grid.append(fragment);
      paint();
    };
    more.addEventListener('click', () => { limit += 24; paint(); });
    [brand, kind, sort, stock].forEach(control => control.addEventListener('change', () => { limit = 24; paint(); }));
    fallback.hidden = true;
    paint();
    clearTimeout(root.limitedFallbackTimer);
    root.removeAttribute('data-limited-loading');
    root.removeAttribute('aria-busy');

    const preview = root.dataset.preview || new URL(location.href).searchParams.get('preview_theme_id');
    const request = async href => {
      const url = new URL(href, location.origin);
      if (url.origin !== location.origin || url.pathname !== location.pathname) throw new Error('Unexpected catalog page');
      url.searchParams.set('view', 'edizioni');
      url.searchParams.set('section_id', root.dataset.limitedSection);
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url.href, {credentials:'same-origin', signal:AbortSignal.timeout(7000)});
      if (!response.ok) throw new Error('Catalog request failed');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const incoming = page.querySelector('[data-limited-grid]');
      if (!incoming) throw new Error('Catalog section missing');
      const expected = Number(url.searchParams.get(grid.dataset.pageParam || 'page'));
      if (incoming.dataset.currentPage && Number(incoming.dataset.currentPage) !== expected) throw new Error('Unexpected catalog pagination');
      return incoming;
    };
    let next = grid.dataset.next;
    try {
      const pageCount = Number(grid.dataset.pageCount);
      const currentPage = Number(grid.dataset.currentPage);
      if (next && Number.isInteger(pageCount) && Number.isInteger(currentPage) && pageCount > currentPage && currentPage > 0 && pageCount <= 100) {
        const urls = Array.from({length:pageCount-currentPage}, (_, index) => {
          const url = new URL(next, location.origin);
          url.searchParams.set(grid.dataset.pageParam || 'page', String(currentPage+index+1));
          return url.href;
        });
        let cursor = 0;
        let failure;
        await Promise.all(Array.from({length:Math.min(3, urls.length)}, async () => {
          while (cursor < urls.length) {
            const index = cursor++;
            try { append(await request(urls[index])); }
            catch (error) { failure ||= error; }
          }
        }));
        if (failure) throw failure;
      } else {
        const visited = new Set();
        while (next) {
          if (visited.has(next) || visited.size >= 100) throw new Error('Repeated catalog page');
          visited.add(next);
          const incoming = await request(next);
          append(incoming);
          next = incoming.dataset.next;
        }
      }
      Array.from(new Set(cards.map(card => card.dataset.brand))).sort().forEach(value => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value.toUpperCase();
        brand.append(option);
      });
      [brand, kind, sort, stock].forEach(control => { control.disabled = false; });
    } catch (error) {
      failed = true;
      errorMessage.hidden = false;
      fallback.hidden = false;
    } finally {
      complete = true;
      paint();
      root.dataset.catalogComplete = failed ? 'partial' : 'true';
    }
  }
  const start = () => document.querySelectorAll('[data-limited-section]').forEach(init);
  start();
  document.addEventListener('shopify:section:load', start);
})();
